import React from "react"
import {
    Grid,
    Typography,
    Box,
    Stack, Divider, Button
} from "@mui/material";
import {UseFormReturn} from "react-hook-form";
import {MatesTextField, withUseFormHook} from "@sinossi/mates-react-library";
import MicrojobCardValidation, {UpdateMicrojobForm} from "./form"
import {t, Trans} from "@lingui/macro";
import RadioGroupRating from "components/microjob/styled-rating";
import {renderProgress} from "components/filledProgressBar/filledProgressBar";

interface MicrojobCardProps extends UseFormReturn {
    data: any
}

interface MicrojobCardState {

}

class MicrojobCard extends React.Component<MicrojobCardProps, MicrojobCardState>
{
    componentDidMount()
    {
        setTimeout(this.setFormValues, 500)
    }

    private setFormValues = () : void => {
        if(this.props.data === null) {
            return
        }


        const formData = UpdateMicrojobForm.fromServerResponse(this.props.data)
        if(formData) {
            this.props.reset(formData as any)
        }
    }


    private submit = () => {

    }

    render(){
        return(
            <Box>
                <Grid container>
                    <Grid item xs={12} md={4} textAlign="center" alignItems="center">
                        <img src={this.props.data.profilePhoto} alt="profile img" width={150} height={150} style={{borderRadius: 80}}/>
                    </Grid>
                    <Grid item xs={12} md={8} sx={{bgcolor:"primary.main", color:"background.default", display: "flex", placeItems: "center"}} px={5}>
                        <Typography variant={"h2"} sx={{color: "background.default"}}>
                            {this.props.data.name}
                        </Typography>
                    </Grid>
                </Grid>
                <Box sx={{ bgcolor: 'background.default', pt: 2, px:2}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4} >
                            <Typography fontSize={"20px"} fontWeight={"500"}>
                                Descrizione
                            </Typography>
                            <Typography  sx={{mt: 2}}>
                                {this.props.data.description}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Typography fontSize={"20px"} fontWeight={"500"}>
                                Informazioni
                            </Typography>
                            <form onSubmit={this.props.handleSubmit(this.submit)}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sx={{mt: 2}}>
                                        <MatesTextField variant={'outlined'}
                                                        label={t({
                                                            id: "microjob.microjob-details.address",
                                                            message: "Indirizzo",
                                                        })}
                                                        name="address"
                                                        control={this.props.control}
                                                        trigger={this.props.trigger}
                                                        formState={this.props.formState}
                                        />
                                    </Grid>
                                    <Divider orientation="horizontal" variant="middle" sx={{ width: "100%", marginTop:"25px" }} />
                                    <Grid item xs={5}>
                                        <MatesTextField variant={'outlined'}
                                                        label={t({
                                                            id: "microjob.microjob-details.phone",
                                                            message: "Telefono",
                                                        })}
                                                        name="phone"
                                                        control={this.props.control}
                                                        trigger={this.props.trigger}
                                                        formState={this.props.formState}
                                        />
                                    </Grid>
                                    <Grid container item justifyContent={"center"}  xs={1}>
                                        <Divider orientation="vertical" variant="middle" sx={{ height: "100%" }} />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <MatesTextField variant={'outlined'}
                                                        label={t({
                                                            id: "microjob.microjob-details.email",
                                                            message: "E-mail",
                                                        })}
                                                        name="email"
                                                        control={this.props.control}
                                                        trigger={this.props.trigger}
                                                        formState={this.props.formState}
                                        />
                                    </Grid>
                                    <Divider orientation="horizontal" variant="middle" sx={{ width: "100%", marginTop:"25px" }} />
                                    <Grid container item xs={12} md={5} sx={{mt: 1}}>
                                        <Grid item xs={12} md={4}>
                                            <Typography>
                                                Valutazioni
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={8}>
                                            {renderProgress(((this.props.data.score*100)/5), 3)}
                                        </Grid>
                                    </Grid>
                                    <Grid container item justifyContent={"center"} xs={1}>
                                        <Divider orientation="vertical" variant="middle" sx={{ height: "100%" }} />
                                    </Grid>
                                    <Grid container item xs={12} md={5} sx={{mt: 1}}>
                                        <Grid item xs={12} md={4}>
                                            <Typography>
                                                Feedback
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={8}>
                                            {RadioGroupRating(this.props.data.feedback)}
                                        </Grid>
                                    </Grid>
                                    <Divider orientation="horizontal" variant="middle" sx={{ width: "100%", marginTop:"25px" }} />
                                </Grid>
                                <Grid container item xs={12} justifyContent={"center"} alignItems={"center"} paddingTop={"30px"} >
                                    <Button
                                        variant="contained"
                                        type={"submit"}
                                        disableElevation
                                        sx={{
                                            textTransform: 'none',
                                            backgroundColor: 'secondary.main',
                                            color: 'white',
                                            paddingX: 5,
                                            mb: 2
                                        }}>
                                        <Typography>
                                            <Trans id="af-asset-submit-button">
                                                Salva
                                            </Trans>
                                        </Typography>
                                    </Button>
                                </Grid>
                            </form>
                        </Grid>

                    </Grid>
                </Box>
            </Box>
        )
    }
}

export default withUseFormHook<UpdateMicrojobForm>(
    MicrojobCard,
    MicrojobCardValidation,
    new UpdateMicrojobForm()
)
